import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { formatName } from '../../helpers'
import StatusChanger from './StatusChanger'
import CommentChanger from './CommentChanger'
import { changePlayerComment } from '../../actions'
import './styles.css'

class Players extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showChanger: {},
      showCommentChanger: {},
      search: '',
      sortByStatus: false,
      sortByTeam: false
    }

    this.switchStatusChanger = this.switchStatusChanger.bind(this)
    this.switchCommentChanger = this.switchCommentChanger.bind(this)
    this.changeComment = this.changeComment.bind(this)
  }

  switchStatusChanger (id) {
    let cloneObj = { ...this.state.showChanger }
    cloneObj[id] = !cloneObj[id]
    this.setState({ showChanger: cloneObj })
  }

  switchCommentChanger (id) {
    let cloneObj = { ...this.state.showCommentChanger }
    cloneObj[id] = !cloneObj[id]
    this.setState({ showCommentChanger: cloneObj })
  }

  changeComment (data) {
    this.props.dispatch(changePlayerComment(data))
  }

  compare (a, b) {
    a = a.toString().toLowerCase()
    b = b.toString().toLowerCase()
    if (a > b) return 1
    if (a < b) return -1
    return 0
  }

  compareNames (a, b) {
    let x = a.split(' ')
    x.shift()
    x = x.join(' ').toLowerCase()
    let y = b.split(' ')
    y.shift()
    y = y.join(' ').toLowerCase()

    if (x > y) return 1
    if (x < y) return -1
    return 0
  }

  getTeamName (id) {
    if (!id) {
      return ''
    }

    const team = this.props.teams.find(t => t.id === id)
    let teamName = team ? team.name : ''
    if (teamName.length > 10) {
      teamName = teamName.slice(0, 9) + '...'
    }

    return teamName
  }

  render () {
    let { players } = this.props
    players = players.filter(p => p.name && p.name.toLowerCase().includes(this.state.search.toLocaleLowerCase()))
    players = this.state.sortByStatus
      ? players.sort((a, b) => this.compare(a.attending_status, b.attending_status) || this.compareNames(a.name, b.name))
      : players
    players = this.state.sortByTeam
      ? players.sort((a, b) => this.compare(this.getTeamName(a.team), this.getTeamName(b.team)) ||
        this.compare(a.attending_status, b.attending_status) || this.compareNames(a.name, b.name))
      : players

    return (
      <div className='main-col-cell' style={{ maxHeight: 'none' }}>
        <div className='dashboard-players'>
          <div className='headline'>
            <h4>Players</h4>
            <div className='search-container'>
              <input
                type='text'
                className='search-input'
                placeholder='search by name'
                value={this.state.search}
                onChange={ev => this.setState({ search: ev.target.value })} />
            </div>
            <div className='players-header'>
              <div className='cell-name'>
                <span
                  onClick={() => this.setState({ sortByStatus: false })}
                  className='cursor-pointer'>⬇ Name</span>
              </div>
              <div className='cell-skills'>
                <span
                  onClick={() => this.setState({ sortByTeam: !this.state.sortByTeam })}
                  className='cursor-pointer'>⬇ Team</span>
              </div>
              <div className='cell-skills'>
                <span
                  onClick={() => this.setState({ sortByStatus: !this.state.sortByStatus })}
                  className='cursor-pointer'>⬇ Status</span>
              </div>
              <div className='cell-team' />
              <div className='cell-team' />
            </div>
          </div>
          <div className='y-scroll-wrap'>
            <div className='y-scroll'>
              <div className='dashboard-players-list'>
                {players && players.map(player => (
                  <div key={player.id} className='dashboard-players-row' >
                    <div className='cell-name'
                      style={{ background: `url(${player.avatar || '/imgs/default-avatar.png'}) no-repeat center /cover` }} />
                    <div className='cell-subject'>
                      <Link to={`/player/${player.id}`} className='color-inherit'>
                        {formatName(player.name)}
                      </Link>
                    </div>
                    <div className='cell-skills'>
                      <Link to={`/team/${player.team}`} className='color-inherit'>
                        {this.getTeamName(player.team)}
                      </Link>
                    </div>
                    <div className='cell-skills'>
                      {player.attending_status}
                    </div>
                    <div className='admin-tab-cell'>
                      <button
                        className='button button-sm'
                        onClick={() => this.switchStatusChanger(player.id)}>Change</button>
                      {this.state.showChanger[player.id] && <StatusChanger {...player} close={this.switchStatusChanger} />}
                    </div>
                    <div className='admin-tab-cell'>
                      <button
                        className='button button-sm'
                        onClick={() => this.switchCommentChanger(player.id)}>Comment</button>
                      {this.state.showCommentChanger[player.id] && <CommentChanger
                        {...player}
                        changeComment={this.changeComment}
                        close={this.switchCommentChanger} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.participants,
    teams: state.team.teams,
    isAuthenticated: state.auth.isAuthenticated
  }
}

export default connect(mapStateToProps)(Players)



// WEBPACK FOOTER //
// ./src/screens/administration/Players.js